<template>
  <div class="home">
    <!-- Hero Section -->
    <header class="header" id="home">
      <div class="container text-center">
        <h1 class="animated fadeInDown">Jens Trompler - <span class="text-gradient">IT Consulting</span></h1>
        <p class="animated fadeInUp">Ihr strategischer Partner für KI-gestützte Lösungen und DevOps-Excellence. Wir transformieren Ihre IT-Infrastruktur für die Herausforderungen von morgen.</p>
        <div class="cta-buttons animated fadeInUp">
          <router-link to="/#kontakt" class="btn-primary">Beratungsgespräch vereinbaren</router-link>
          <router-link to="/#services" class="btn-secondary">Unsere Leistungen</router-link>
        </div>
        <div class="hero-shape-1"></div>
        <div class="hero-shape-2"></div>
      </div>
    </header>
    
    <!-- Main Content -->
    <main>
      <!-- KI & DevOps Schwerpunkte -->
      <section class="intro-section" id="intro">
        <div class="container">
          <div class="section-title text-center">
            <span class="subtitle">Unsere Schwerpunkte</span>
            <h2>KI-Integration & <span class="text-gradient">DevOps</span> Excellence</h2>
            <p class="lead">Wir kombinieren künstliche Intelligenz mit fortschrittlichen DevOps-Praktiken, um Ihr Unternehmen zukunftssicher zu machen.</p>
          </div>
          <div class="features-grid">
            <div class="feature-item animated fadeInUp">
              <div class="feature-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 512 512">
                  <path fill="currentColor" d="M208 256c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16zm112 0c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16zM256 32c97.9 0 176 62.5 176 144v16c0 35.5-25.3 65.8-59.1 78.1c-6.5 13.4-13.5 25.3-21.3 35.6c-17.2 22.8-36.9 38.9-59.6 50.3V400h32c17.7 0 32 14.3 32 32v12c0 2.7-.4 5.4-1.2 8H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16h44.3c-.8-2.6-1.2-5.3-1.2-8V432c0-17.7 14.3-32 32-32h32v-44.2c-22.7-11.4-42.4-27.5-59.6-50.3c-7.8-10.3-14.9-22.3-21.3-35.6C137.3 257.8 112 227.5 112 192v-16C112 94.5 190.1 32 288 32h-32zm0 304c29.8 0 56.6-10.5 77.5-27.5c20.6-16.8 36.1-39.6 48.3-66.7c-35.3-2.2-68.3-10.2-98.2-22.5C247.3 210.9 224 198.9 224 192c0 0-30.4-2.9-59.7 8.6c-30.1 11.8-54.8 34.3-74.9 71c1.7 3.7 3.9 7 6.5 9.8c15 16 49.1 36 68 44c14 5.9 33.9 11.6 56.1 11.6zm109.1-122.3c11.7-1.3 22.6-5.2 32.2-11.3c16.7-10.6 26.7-28.7 26.7-48.4v-16C424 109.5 346.8 64 256 64S88 109.5 88 144v16c0 19.8 10 37.8 26.7 48.4c9.5 6.1 20.5 10 32.2 11.3c1.9-5.3 4-10.3 6.3-15.1c-4-.8-7.8-2-11.4-3.5c-11.1-4.8-17.9-16.2-17.9-28.8v-16C124 124.2 187.2 88 256 88s132 36.2 132 80v16c0 12.6-6.7 24-17.9 28.8c-3.5 1.5-7.4 2.7-11.4 3.5c2.2 4.7 4.3 9.8 6.3 15.1z"/>
                </svg>
              </div>
              <h3>KI-Lösungen</h3>
              <p>Von Prozessautomatisierung bis zu prädiktiver Analyse: Wir implementieren maßgeschneiderte KI-Lösungen, die Ihr Geschäft revolutionieren.</p>
              <a href="#ki" class="feature-link">Mehr erfahren →</a>
            </div>
            <div class="feature-item animated fadeInUp">
              <div class="feature-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 512 512">
                  <path fill="currentColor" d="M256 64c69.2 0 128.6 42.5 153.8 102.8c.2 .6 .7 1 1.3 1.2l58.5 19.5c1.7 .6 2.7 2.3 2.3 4.1c-.3 1.1-.7 2.2-1 3.3c-3.2 10.4-7.4 20.3-12.5 29.8L448 256l10.4 31.3c5.1 9.5 9.3 19.4 12.5 29.8c.3 1.1 .7 2.2 1 3.3c.3 1.8-.7 3.5-2.3 4.1l-58.5 19.5c-.6 .2-1.1 .7-1.3 1.2C384.6 405.5 325.2 448 256 448c-70.7 0-131.1-44.2-155.4-106.5c-.2-.5-.7-1-1.3-1.2l-58.5-19.5c-1.7-.6-2.7-2.3-2.3-4.1c.3-1.1 .7-2.2 1-3.3c3.2-10.4 7.4-20.3 12.5-29.8L62.4 256 52 224.7c-5.1-9.5-9.3-19.4-12.5-29.8c-.3-1.1-.7-2.2-1-3.3c-.3-1.8 .7-3.5 2.3-4.1l58.5-19.5c.6-.2 1.1-.7 1.3-1.2C124.9 106.5 185.3 64 256 64zm0 340.9c39.4 0 75.9-11.9 106.3-32.3c-3.6-9.2-6.8-18.6-9.5-28.1c-6.3-22.5-10.5-45.9-12.3-69.6c-27.1 7-55.9 10.8-84.5 10.8c-28.4 0-56.3-3.6-82.5-10.4c-1.9 23.7-6.2 47.1-12.6 69.6c-2.8 9.9-6.2 19.6-10 29.1c30.6 21 67.5 33 106.2 33zm-106.9-55c3.4-8.5 6.4-17.3 8.9-26.2c6-21.7 10-44 12-66.4c-23-7.7-44.8-17.4-65-29c-17.7-10.1-33.9-21.8-48.1-35.1c4.2 61.2 27.3 116.8 64.7 161.5c8.6 10.3 18 19.9 28.2 28.5c-.1-.8-.3-1.5-.4-2.3c-.2-10.2 .1-20.5 1.1-30.9c-.6 0-1.3 0-1.9 0c-1.2 0-2.4-.1-3.7-.1c1.4 0 2.5 0 3.7 .1zM350.9 162c-14.1 13.1-29.9 24.6-47.3 34.4c-19.7 11.1-41 20.4-63.5 27.7c1.6 22.9 5.5 45.6 11.4 67.7c2.5 9.2 5.4 18.1 9 26.8c1 2.9 2 5.8 3.1 8.6c1.1 2.7-1.1-1.8 .6 1.7c1 2.1 1.9 4.2 2.9 6.3c1.5-1 3-2 4.5-3c10.9-7.5 21.3-16 31-25.1c38.3-36.1 68.3-80.5 87.8-129.8c-.7-5-1.4-10.1-2.1-15.1c-13.2 7-27 13-41.2 18.1c1.4 0 2.8-.1 4.2-.1c7.9 0 15.6 .2 23.4 .6c11.2-5.9 21.7-13.2 31.3-21.6c.9-8 1.4-16.1 1.4-24.4c0-18.5-2.4-36.5-6.7-53.5c-5.8 6.7-12 13.1-18.7 19c-.3 18.5-3.8 36.9-10.3 54.3zm168.9 55c8.9-17.2 15.5-35.7 19.7-55c-4.2-5.5-8.8-10.7-13.8-15.5c-2.5 14.8-6.3 29.5-11.4 43.8c-1.9 5.3-3.9 10.7-6.1 15.8c3.9 3.7 7.7 7.4 11.4 11.3c0-.1 .1-.3 .1-.4zm-21.8-5.5c0-.7 .1-1.3 .1-2c0 .7-.1 1.3-.1 2zm-301.5-4.6c-3-5.5-5.9-11.3-8.4-17.1c-4.6-10.8-8-22-10.1-33.3c-4.4 5.7-8.5 11.9-12.2 18.2c7.7 20.9 17.3 40.9 28.7 59.5c.8-.7 1.7-1.4 2.5-2.1c-.2-8.4 0-16.8 .6-25.1c-.3 0-.7 0-1-.1zM465 165c11.8 10.9 21.9 23.7 29.7 37.8c-2 4.6-4.3 9.1-6.9 13.3c2.6 10.6 4.3 21.4 5.2 32.5c.8 10.3 .5 20.7-.6 30.8c6.5 10.4 11.8 21.2 15.8 32.3c1.2-11.8 1.8-23.8 1.8-36c0-47.5-9.1-92.9-25.5-134.3c-6.5 7.8-12.6 15.9-18.3 24l-1.2-.4zm-419.3 4c-6.6-12.4-9.3-24.9-10.8-33.3c-21.7 31.6-38.7 66.8-50.1 104.2C10.8 305 32.8 366.6 67 419.4c5.1-10.3 11-20.2 17.9-29.7c-31.9-50.9-50.2-110.3-50.2-173.7c0-20.6 1.9-40.8 5.6-60.3c1.8 2.6 3.8 5.1 5.8 7.4c1.2-13.8 .5-15.2 0-28.1zm184-108.6c-5.1 9.4-15 16-26.4 16.2c1.6 2.5 3.2 5 4.9 7.4c19.8 2.7 38.5 7.5 56.1 14.1c-9.8-23.1-21.9-44.8-35.8-64.9c-.5 9.5-1.3 18.3-3.4 25.6c1.5 .5 3.1 1 4.6 1.6zM182.1 62c16.8 19.2 31.1 40.7 42.6 63.9c12.5-5.2 25.6-9.2 39.2-11.9c11.9-2.4 22.5-3.9 32.2-4.8c-27.5-28.5-63.2-49.2-103.1-59.2c-3.6 4-7.1 8.2-10.8 12z"/>
                </svg>
              </div>
              <h3>DevOps Transformation</h3>
              <p>Optimieren Sie Ihre Entwicklungsprozesse durch CI/CD-Pipelines, Container-Orchestrierung und Infrastructure as Code.</p>
              <a href="#devops" class="feature-link">Mehr erfahren →</a>
            </div>
            <div class="feature-item animated fadeInUp">
              <div class="feature-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 512 512">
                  <path fill="currentColor" d="M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0zm0 66.8V444.8C394 378 431.1 230.1 432 141.4L256 66.8l0 0z"/>
                </svg>
              </div>
              <h3>Security-First Ansatz</h3>
              <p>Integration von Sicherheit in jeden Schritt der Entwicklung und des Betriebs durch moderne DevSecOps-Praktiken.</p>
              <a href="#devops" class="feature-link">Mehr erfahren →</a>
            </div>
          </div>
        </div>
      </section>
      
      <!-- KI-Lösungen -->
      <section class="ki-section" id="ki">
        <div class="container">
          <div class="section-title text-center">
            <span class="subtitle">KI-Lösungen</span>
            <h2>Innovative <span class="text-gradient">KI-Lösungen</span> für Ihr Unternehmen</h2>
            <p class="lead">Wir nutzen die Kraft der künstlichen Intelligenz, um Ihre Geschäftsprozesse zu optimieren und neue Werte zu schaffen.</p>
          </div>
          <div class="features-grid">
            <div class="feature-item animated fadeInUp">
              <div class="feature-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 512 512">
                  <path fill="currentColor" d="M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113C-2.3 103.6-2.3 88.4 7 79s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"/>
                </svg>
              </div>
              <h3>Datenanalyse & Prognosen</h3>
              <p>Nutzen Sie die Macht Ihrer Daten für fundierte Geschäftsentscheidungen und präzise Vorhersagen.</p>
            </div>
            <div class="feature-item animated fadeInUp">
              <div class="feature-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 512 512">
                  <path fill="currentColor" d="M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 320 512V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM512 288H320v32c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V288z"/>
                </svg>
              </div>
              <h3>Prozessautomatisierung</h3>
              <p>Automatisieren Sie wiederkehrende Aufgaben und steigern Sie die Effizienz Ihrer Geschäftsprozesse.</p>
            </div>
            <div class="feature-item animated fadeInUp">
              <div class="feature-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 512 512">
                  <path fill="currentColor" d="M123.6 391.3c12.9-9.4 29.6-11.8 44.6-6.4c26.5 9.6 56.2 15.1 87.8 15.1c124.7 0 208-80.5 208-160s-83.3-160-208-160S48 160.5 48 240c0 32 12.4 62.8 35.7 89.2c8.6 9.7 12.8 22.5 11.8 35.5c-1.4 18.1-5.7 34.7-11.3 49.4c17-7.9 31.1-16.7 39.4-22.7zM21.2 431.9c1.8-2.7 3.5-5.4 5.1-8.1c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208s-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6c-15.1 6.6-32.3 12.6-50.1 16.1c-.8 .2-1.6 .3-2.4 .5c-4.4 .8-8.7 1.5-13.2 1.9c-.2 0-.5 .1-.7 .1c-5.1 .5-10.2 .8-15.3 .8c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c4.1-4.2 7.8-8.7 11.3-13.5c1.7-2.3 3.3-4.6 4.8-6.9c.1-.2 .2-.3 .3-.5z"/>
                </svg>
              </div>
              <h3>Chatbots & Assistenten</h3>
              <p>Verbessern Sie den Kundenservice mit intelligenten, KI-gestützten Chatbots und digitalen Assistenten.</p>
            </div>
          </div>
        </div>
      </section>
      
      <!-- DevOps -->
      <section class="devops-section" id="devops">
        <div class="container">
          <div class="section-title text-center">
            <span class="subtitle">DevOps Transformation</span>
            <h2>Beschleunigen Sie Ihre <span class="text-gradient">Entwicklungsprozesse</span></h2>
            <p class="lead">Mit unseren DevOps-Lösungen optimieren Sie Ihre Entwicklungsprozesse, verbessern die Zusammenarbeit und verkürzen die Time-to-Market.</p>
          </div>
          <div class="features-grid">
            <div class="feature-item animated fadeInUp">
              <div class="feature-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 512 512">
                  <path fill="currentColor" d="M156.6 384.9L125.7 354c-8.5-8.5-11.5-20.8-7.7-32.2c3-8.9 7-20.5 11.8-33.8L24 288c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3l82.3 0c2.4-4 4.8-7.7 7.2-11.3C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7c-3.5 2.4-7.3 4.8-11.3 7.2v82.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9V380.8c-14.1 4.9-26.4 8.9-35.7 11.9c-11.2 3.6-23.4 .5-31.8-7.8zM384 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"/>
                </svg>
              </div>
              <h3>CI/CD Pipelines</h3>
              <p>Automatisieren Sie Ihre Build-, Test- und Deployment-Prozesse für schnellere und zuverlässigere Softwarelieferung.</p>
            </div>
            <div class="feature-item animated fadeInUp">
              <div class="feature-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 512 512">
                  <path fill="currentColor" d="M266.3 48.3L232.5 73.6c-5.4 4-8.4 10.4-8.4 17.1v17.4l-74.9 43.3c-6.6 3.8-14.8 3.8-21.4 0L53 108.1v-17.6c0-7-3.4-13.6-9.2-17.6L9.5 48.3C3.9 44.2 0 37.9 0 31.2C0 15.1 13.1 2 29.2 2H128 234.8c16.1 0 29.2 13.1 29.2 29.2c0 6.7-3.9 13-9.7 17.1zM256 111.9c0-8.2-6.6-14.8-14.8-14.8s-14.8 6.6-14.8 14.8v16.2c0 8.2 6.6 14.8 14.8 14.8s14.8-6.6 14.8-14.8V111.9zM365.8 429.2c0 8.2 6.6 14.8 14.8 14.8s14.8-6.6 14.8-14.8V413c0-8.2-6.6-14.8-14.8-14.8s-14.8 6.6-14.8 14.8v16.2zm-14.8-43l34.8-26.1c6.1-4.6 9.2-11.9 9.2-19.4c0-17.4-15.6-30.5-32.8-28c-9.9 1.4-18.4 8.1-22.3 17.3l-25.6 59.8c-3.1 7.3-9.9 12.4-17.8 13.6l-46.5 6.8c-8.4 1.2-15.8 6.5-19.3 14l-10.7 22.8c-4.8 10.3-15.2 16.9-26.6 16.9H143.6c-9.8 0-18.4-6.8-20.4-16.4l-7.8-36.8c-1.7-7.9-6.3-14.8-13-19.2l-41.1-26.5c-9-5.8-12.3-17.3-8.4-27.3c4.9-12.5 20.5-18 32.5-11.3L144 335.9c5.8 3.1 12.6 3.3 18.5 .4l34.9-16.9c8.2-4 15.1-10 20.2-17.3l37-53.9c9.4-13.7 25-21.2 41.2-21.2c22.1 0 43.1 14.3 47.7 35.9l7.1 33.1c2.8 13.4 2.3 27.4-1.7 40.5l-12.2 40.9-95 15.8c-12.4 2.1-21.7 12.5-21.7 25.1v17.1c0 14 11.3 25.2 25.2 25.2H261c10.1 0 19.7-4.7 25.9-12.8l50.9-66.4c7.5-9.7 18.5-15.9 30.6-17.2l47.5-5.3c12.6-1.4 22.1-12.2 22.1-24.9c0-13.8-11.2-25-25-25h-59.8c-7.6 0-14.7 3.6-19.2 9.6l-18.4 24.9c-4.4 5.9-9.2 11.5-14.3 16.8c-7.5 7.7-17.7 12.1-28.5 12.1c-17.8 0-33.2-12.1-37.6-29.3L248.9 440c-3.4 4.4-5.5 9.9-5.5 15.8c0 14.3 11.6 25.9 25.9 25.9h100.5c11.9 0 22.7-7.2 27.1-18.3c4.4-11.1 1.9-23.7-6.4-32L365.8 410c0 8.2 6.6 14.8 14.8 14.8s14.8-6.6 14.8-14.8V393.8c0-8.2-6.6-14.8-14.8-14.8s-14.8 6.6-14.8 14.8v-7.7zM479.2 82H352.3c-16.1 0-29.2 13.1-29.2 29.2c0 6.7 3.9 13 9.7 17.1l33.8 25.3c5.9 4.4 9.2 11 9.2 18v17.6l77.8 43.3c6.6 3.7 14.8 3.7 21.4 0L549.8 190v-17.4c0-6.7 3-13.1 8.4-17.1l33.8-25.3c5.8-4 9.2-10.5 9.2-17.6c0-16.1-13.1-29.2-29.2-29.2h-92.9z"/>
                </svg>
              </div>
              <h3>Container-Orchestrierung</h3>
              <p>Implementieren und optimieren Sie Kubernetes-Umgebungen für skalierbare und zuverlässige Anwendungsbereitstellung.</p>
            </div>
            <div class="feature-item animated fadeInUp">
              <div class="feature-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 512 512">
                  <path fill="currentColor" d="M211.2 488.8c-44.3-3.2-86.8-19.6-120.8-46.5l60.6-60.6c21.9 14.9 48.2 23.7 76.5 23.7c1.4 0 2.9 0 4.3-.1C137.1 396.2 64 317.4 64 224c0-17.7 14.3-32 32-32h32 32 32 18.5c-1.8-5-2.5-10.2-2.5-15.4c0-6.6 1.8-13.3 5.5-19.6l5.4-9.3L192 96l-42.3 42.3c-3.3-7.4-5.2-15.5-5.2-23.8c0-27.2 18.1-50.2 42.9-57.6c1.8-.5 3.4-1.6 4.4-3.1l9.8-14.7C210.1 32.3 219.3 32 224 32h64c4.7 0 13.9 .3 22.5 7.2l9.8 14.7c1 1.5 2.6 2.6 4.4 3.1C349.5 64.5 367.6 87.5 367.6 114.6c0 10.9-3.2 21.2-8.8 30l-6 9.5c-1.2 2-1.9 4.2-2.3 6.5H360h32 32 32c17.7 0 32 14.3 32 32c0 93.4-73.1 172.2-168 191.9c1.4 .1 2.7 .1 4.2 .1c28.3 0 54.6-8.8 76.5-23.7l60.6 60.6c-34 26.9-76.5 43.3-120.8 46.5c-3.3 .2-6.6 .4-10 .4s-6.6-.1-9.8-.4zM32 192C14.3 192 0 177.7 0 160s14.3-32 32-32H96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32zm192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H224zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384z"/>
                </svg>
              </div>
              <h3>Infrastructure as Code</h3>
              <p>Verwalten Sie Ihre Infrastruktur wie Ihren Quellcode für mehr Konsistenz, Compliance und Skalierbarkeit.</p>
            </div>
          </div>
        </div>
      </section>
      
      <!-- Technologie-Stack -->
      <section class="tech-stack-section" id="technology">
        <div class="container">
          <div class="section-title text-center">
            <span class="subtitle">Unsere Technologien</span>
            <h2>Moderne <span class="text-gradient">Technologien</span> für moderne Herausforderungen</h2>
          </div>
          <div class="tech-grid">
            <div class="tech-category">
              <h3>KI & Machine Learning</h3>
              <ul class="tech-list">
                <li>TensorFlow & PyTorch</li>
                <li>Natural Language Processing</li>
                <li>Computer Vision</li>
                <li>Predictive Analytics</li>
                <li>MLOps & KI-Integration</li>
              </ul>
            </div>
            <div class="tech-category">
              <h3>DevOps & Cloud</h3>
              <ul class="tech-list">
                <li>Kubernetes & Docker</li>
                <li>AWS, Azure & GCP</li>
                <li>CI/CD (Jenkins, GitHub Actions)</li>
                <li>Terraform & Ansible</li>
                <li>Monitoring & Observability</li>
              </ul>
            </div>
            <div class="tech-category">
              <h3>Software-Entwicklung</h3>
              <ul class="tech-list">
                <li>Microservices-Architekturen</li>
                <li>API-Design & -Entwicklung</li>
                <li>Cloud-Native Anwendungen</li>
                <li>Test-Automatisierung</li>
                <li>Legacy-Modernisierung</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      
      <!-- Integrated Services Section - Kurzer Überblick -->
      <section id="services" class="py-5">
        <IntegratedServices/>
          <AppServices/>
      </section>
      
      <!-- Success Stories Section -->
      <section id="erfolgsgeschichten" class="py-5">
        <SuccessStories/>
      </section>
      
      <!-- Testimonials Section -->
      <section id="referenzen" class="py-5">
        <TestimonialSection/>
      </section>
      
      <!-- Contact Section -->
      <section id="kontakt">
        <AppKontakt/>
        <div class="text-center mt-5">
        </div>
      </section>
      
    </main>
  </div>
</template>

<script>
import AppKontakt from './Contact.vue';
import AppServices from './Services.vue';
import IntegratedServices from '@/components/IntegratedServices.vue';
import SuccessStories from '@/components/SuccessStories.vue';
import TestimonialSection from '@/components/TestimonialSection.vue';

export default {
  name: 'AppHome',
  components: {
    AppKontakt,
    IntegratedServices,
    SuccessStories,
    AppServices,
    TestimonialSection
  },
  mounted() {
    // Handle smooth scrolling for hash links in the SPA
    this.handleHashScroll();
    
    // Setup event listeners for all hash links within this component
    this.setupSmoothScrolling();
    
    // Listen for hash changes (which can happen when using the browser's back/forward buttons)
    window.addEventListener('hashchange', this.handleHashScroll);
  },
  beforeUnmount() {
    // Remove event listener when component is unmounted
    window.removeEventListener('hashchange', this.handleHashScroll);
  },
  methods: {
    handleHashScroll() {
      // Get the hash from the URL, remove the # character
      const hash = window.location.hash.substring(1);
      
      if (hash) {
        // Get target element
        const targetElement = document.getElementById(hash);
        
        if (targetElement) {
          // Use setTimeout to ensure the DOM is fully updated
          setTimeout(() => {
            window.scrollTo({
              top: targetElement.offsetTop - 70, // Offset for navbar height
              behavior: 'smooth'
            });
          }, 100);
        }
      }
    },
    setupSmoothScrolling() {
      // Select all hash links within this component
      const links = this.$el.querySelectorAll('a[href^="#"]');
      
      links.forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          
          const targetId = link.getAttribute('href').substring(1);
          const targetElement = document.getElementById(targetId);
          
          if (targetElement) {
            window.scrollTo({
              top: targetElement.offsetTop - 70, // Offset for navbar height
              behavior: 'smooth'
            });
            
            // Update URL hash without page jump
            history.pushState(null, null, `#${targetId}`);
          }
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";

/* Home Page Styles */
.home {
  overflow: hidden;
}

/* Feature Links Styles */
.feature-link {
  display: inline-block;
  margin-top: 1rem;
  color: $accent-color;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 0;
    height: 2px;
    background: $accent-gradient;
    transition: width 0.3s ease;
  }
  
  &:hover {
    color: darken($accent-color, 10%);
    
    &::after {
      width: 100%;
    }
  }
}

/* Fade-in Animation */
.fade-in {
  opacity: 0;
  animation: fadeInAnimation ease 2s;
  animation-fill-mode: forwards;
}

@keyframes fadeInAnimation {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

/* KI Section */
.ki-section {
  padding: 100px 0;
  background: linear-gradient(180deg, rgba($primary-color, 0.2), rgba($accent-color, 0.03));
  position: relative;
}

/* DevOps Section */
.devops-section {
  padding: 100px 0;
  background: linear-gradient(0deg, rgba($primary-color, 0.2), rgba($accent-color, 0.03));
  position: relative;
}

/* Tech Stack Section */
.tech-stack-section {
  padding: 100px 0;
  background: linear-gradient(0deg, rgba($accent-color, 0.03), rgba($primary-color, 0.2));
  position: relative;
}

.tech-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin-top: 50px;
}

.tech-category {
  background: rgba($secondary-color, 0.4);
  border-radius: 15px;
  padding: 30px;
  backdrop-filter: blur(5px);
  border: 1px solid rgba($accent-color, 0.1);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
    border-color: rgba($accent-color, 0.3);
  }
  
  h3 {
    font-size: 1.4rem;
    color: $accent-color;
    margin-bottom: 20px;
    position: relative;
    padding-bottom: 15px;
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 40px;
      height: 3px;
      background: $accent-gradient;
      border-radius: 3px;
    }
  }
}

.tech-list {
  list-style: none;
  padding: 0;
  margin: 0;
  
  li {
    padding: 10px 0;
    border-bottom: 1px solid rgba($accent-color, 0.1);
    color: $muted-text-color;
    position: relative;
    padding-left: 25px;
    
    &::before {
      content: '→';
      position: absolute;
      left: 0;
      color: $accent-color;
    }
    
    &:last-child {
      border-bottom: none;
    }
  }
}

/* Testimonials Section */
.references-section {
  padding: 100px 0;
  position: relative;
  background: linear-gradient(180deg, $background-color, darken($background-color, 3%));
}

.testimonials-carousel {
  margin-top: 50px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.testimonial-item {
  background: rgba($secondary-color, 0.3);
  border-radius: 15px;
  padding: 30px;
  backdrop-filter: blur(5px);
  border: 1px solid rgba($accent-color, 0.1);
  transition: all 0.3s ease;
  position: relative;
  
  &::before {
    content: '"';
    position: absolute;
    top: 20px;
    left: 20px;
    font-size: 5rem;
    font-family: Georgia, serif;
    color: rgba($accent-color, 0.1);
    line-height: 1;
  }
  
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
  }
  
  .testimonial-content {
    position: relative;
    z-index: 1;
    
    .client-logo {
      display: flex;
      justify-content: center;
      margin-bottom: 20px;
      
      svg {
        filter: drop-shadow(0 4px 6px rgba($accent-color, 0.2));
        transition: transform 0.3s ease;
      }
      
      &:hover svg {
        transform: scale(1.1);
      }
    }
    
    p {
      font-size: 1.1rem;
      font-style: italic;
      color: $text-color;
      margin-bottom: 20px;
      line-height: 1.6;
    }
    
    .client-info {
      margin-top: 25px;
      padding-top: 15px;
      border-top: 1px solid rgba($accent-color, 0.1);
      
      h4 {
        font-size: 1.1rem;
        color: $accent-color;
        margin: 0;
      }
      
      span {
        font-size: 0.9rem;
        color: $muted-text-color;
      }
    }
  }
}

/* Responsive Styles */
@media (max-width: 768px) {
  .tech-grid,
  .testimonials-carousel {
    grid-template-columns: 1fr;
  }
}
</style>

